module.exports = __webpack_public_path__ + "img/hello-hi.b440fe8b.gif";